import ErrorHandler from '@/ErrorHandler';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import { GET_EPSILON_SEGMENTS } from '@/org-app/store/modules/epsilonSegments/mutation-types';
import i18n from '@/vueI18n';

export default {
  async getEpsilonSegmentsByOrg({ commit }, { queryParams }) {
    if (queryParams.customQueryParams.showLoader) {
      GlobalEventBus.$emit(GlobalEvents.loading);
    }
    return new Promise((resolve, reject) => {
      API.instance.getEpsilonSegmentsByOrg(
        queryParams.customQueryParams.dataProviderId,
        queryParams,
        (res) => {
          commit(GET_EPSILON_SEGMENTS, res);
          resolve(res);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
        (error) => {
          ErrorHandler.showError(i18n.global.t('messages.failedToGetAudienceFile'), error);
          reject(error);
          GlobalEventBus.$emit(GlobalEvents.loaded);
        },
      );
    });
  },
};
